export class LocalStorageService {
  public static readonly STORAGE_PREFIX: string = 'SOP_EMPLOYEE_PORTAL_'

  public static readonly KEYS = {
    COMPANY_DOMAIN: 'companyDomain'
  }

  constructor() {}

  public static set(key: string, data: any) {
    localStorage.setItem(LocalStorageService.STORAGE_PREFIX + key, JSON.stringify(data))
  }

  public static get(key: string): any {
    return JSON.parse(localStorage.getItem(LocalStorageService.STORAGE_PREFIX + key))
  }

  public static remove(key: string) {
    localStorage.removeItem(LocalStorageService.STORAGE_PREFIX + key)
  }
}
